<header>
  <div class="container">
    <div class="navbar">
      <div class="logo"><img src="./assets/images/legance-color.svg" routerlink="" alt="" height="155"></div>

    </div>
  </div>
  <hr>
</header>
<!--======================= Main Section Body ==================== -->
<div class="main-title">
  <div class="container">
    <!-- <h1>Positions</h1> -->
    <!-- <h1>{{ "POSITION_PAGE.POSITIONS" | translate }}</h1> -->
    <!-- <h1>{{'PrivatePolicy' | translate}}</h1> -->
  </div>
</div>
<div class="the-content-wrap pt-5">

  <div class="the-content container" [innerHTML]="privacyData">

  </div>
  <div class="container privacy-policy-container">

    <h4 class="text-center">INFORMATIVA RELATIVA AL TRATTAMENTO DEI DATI PERSONALI RESA AGLI UTENTI AI SENSI </h4>

     <h4 class="text-center">DELL’ART. 13 DEL REGOLAMENTO EUROPEO 2016/679</h4>
    <h4  class="privacy-title">1. Premessa</h4>

    <p>Gentile Utente ai sensi della vigente normativa in materia di protezione di dati (Regolamento Europeo
      2016/679, Codice Privacy così come novellato dal Decreto 101/2018; Provvedimenti del Garante per la
      Protezione dei Dati Personali) e successive variazioni, la nostra società le conferisce le seguenti informazioni
      circa il trattamento dei dati personali</p>

    <p>Si precisa che la presente informativa è resa agli utenti in relazione al sito internet consultabile
      all'indirizzo <a style="text-decoration: underline;" target="_blank"
        href="https://www.all-projects.it/">https://www.all-projects.it/</a>. Si precisa che
      l'informativa non è da considerarsi valida per altri siti web eventualmente consultabili tramite link presenti sui
      siti internet a dominio del titolare, che non è da considerarsi in alcun modo responsabile dei siti internet dei
      terzi.</p>
    <p>Pertanto, per il dettaglio circa l'impiego di cookie da parte di tali aziende si rimanda alle informative rese
      dalle suddette aziende terze. Si tratta di un'informativa che è resa anche ai sensi del <a target="_blank"
        style="text-decoration: underline;"
        href="https://www.garanteprivacy.it/web/guest/home/docweb/-/docweb-display/docweb/1311248"> Regolamento Europeo
        2016/679.</a> L'informativa si ispira anche alla Raccomandazione n. 2/2001 che le autorità europee per la
      protezione
      dei dati personali, hanno adottato il 17 maggio 2001 per individuare alcuni requisiti minimi per la raccolta di
      dati personali on-line, e, in particolare, le modalità, i tempi e la natura delle informazioni che i titolari del
      trattamento devono fornire agli utenti quando questi si collegano a pagine web, indipendentemente dagli scopi del
      collegamento, nonché a quanto previsto dalla Direttiva 2002/58/CE, come aggiornata dalla <a target="_blank"
      style="text-decoration: underline;"
      href="https://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=OJ:L:2009:337:0011:0036:it:PDF">Direttiva 2009/136/CE,</a> in
      materia di Cookie, nonché a quanto previsto dalle Linee guida cookie e altri strumenti di tracciamento
      dell'Autorità Garante per la Protezione dei Dati Personali del 10 giugno 2021.</p>

    <h4 class="privacy-title">2. Titolare del trattamento</h4>

    <p>Il Titolare del trattamento ai sensi della vigente normativa in materia di protezione dei dati è l'azienda
    </p>
    <p>
      ALL PROJECTS con sede legale e operativa in della Commenda, 20 - 20122 Milano – Tel. 02 3826 6440. Eventuali
      richieste
      di informazioni e/o chiarimenti possono essere richiesti al Titolare utilizzando i recapiti telefoni sopra
      indicati oppure inviando una mail all'indirizzo <a target="_blank" style="text-decoration: underline;"
        href="mailto:info@all-projects.it">info@all-projects.it</a>.
    </p>

    <h4 class="privacy-title">3. Tipi di dati trattati</h4>

    <p>Dato personale e identificativo.</p>
    <ul>
      <li> <b> Dato personale:</b> qualsiasi informazione riguardante una persona fisica identificata o identificabile
        («interessato»); si considera identificabile la persona fisica che può essere identificata,
        direttamente o indirettamente, con particolare riferimento a un identificativo come il nome, un
        numero di identificazione, dati relativi all’ubicazione, un identificativo online o a uno o più elementi
        caratteristici della sua identità fisica, fisiologica, genetica, psichica, economica, culturale o sociale;</li>
      <li><b> Dati identificativi:</b> i dati personali che permettono l&#39;identificazione diretta dell&#39;interessato
        (quali a
        titolo esemplificativo nome, cognome, indirizzo e-mail, indirizzo, numero di telefono, ecc..).</li>
    </ul>
    <h5>Dati di navigazione</h5>

    <p>I sistemi informatici e le procedure software preposte al funzionamento di questo sito web acquisiscono,
      nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell&#39;uso dei
      protocolli di comunicazione di Internet. Si tratta di informazioni che non sono raccolte per essere associate
      a interessati identificati, ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni
      con dati detenuti da terzi, permettere di identificare gli utenti. In questa categoria di dati rientrano gli
      indirizzi IP o i nomi a dominio dei computer utilizzati dagli utenti che si connettono al sito, gli indirizzi in
      notazione URI (Uniform Resource Identifier) delle risorse richieste, l&#39;orario della richiesta, il metodo
      utilizzato nel sottoporre la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico
      indicante lo stato della risposta data dal server (buon fine, errore, ecc.) ed altri parametri relativi al sistema
      operativo e all&#39;ambiente informatico dell&#39;utente. Questi dati vengono utilizzati al solo fine di ricavare
      informazioni statistiche anonime sull&#39;uso del sito e per controllarne il corretto funzionamento.</p>

    <h5>
      Difesa in giudizio
    </h5>
    <p>
      I Dati Personali dell’Utente possono essere utilizzati per la difesa da parte del Titolare in giudizio o nelle
      fasi
      propedeutiche alla sua eventuale instaurazione, da abusi nell&#39;utilizzo della stessa o dei servizi connessi da
      parte dell’Utente. I dati potrebbero essere utilizzati per l&#39;accertamento di responsabilità in caso di
      ipotetici
      reati informatici ai danni del sito.
    </p>


    <h5>
      Manutenzione
    </h5>
    <p>
      I Dati Personali dell’Utente possono essere trattati con modalità e finalità aggiuntive legate alla
      manutenzione dei sistemi.
    </p>


    <h5>
      Dati forniti volontariamente dall&#39;utente
    </h5>
    <p>
      L&#39;invio facoltativo, esplicito e volontario di posta elettronica agli indirizzi indicati su questo sito o la
      compilazione di form di raccolta dati, comporta la successiva acquisizione dell&#39;indirizzo del mittente,
      necessario per rispondere alle richieste, nonché degli eventuali altri dati personali inseriti.
    </p>


    <h5>
      Informative specifiche
    </h5>
    <p>
      Informative specifiche potrebbero essere presentate nelle pagine del Sito in relazione a particolari servizi o
      trattamenti dei Dati forniti dall’Utente o dall’Interessato.
    </p>


    <h5>
      Cookies
    </h5>
    <p>
      L’impiego dei cookie da parte del presente sito internet viene normato dalla cookie policy alla quale si
      rimanda.
    </p>
    <h4 class="privacy-title">4. Finalità del trattamento</h4>

    <p>I dati di natura personale volontariamente forniti saranno oggetto di trattamento per le seguenti finalità,
      fino a sua opposizione:</p>
    <ul>
      <li>navigazione sul presente sito internet;</li>
      <li>eventuale richiesta di contatto, con invio di informazioni da Lei richieste; l’utente, infatti, può
        contattare l’Azienda utilizzando i recapiti telefonici e di posta elettronica ubicati al fondo della
        homepage ove l’utente può reperire i riferimenti del Titolare. Il ricevimento di comunicazioni
        spontanee da parte degli utenti comporta necessariamente per il Titolare l’acquisizione
        dell’indirizzo mail e/o del nominativo dell’utente. La finalità di tale raccolta è legata alla fornitura di
        informazioni circa le prestazioni di beni e /o di servizi erogati</li>
      <li>eventuale compilazione di form di raccolta dati in aree dedicate.</li>
    </ul>

    <h4 class="privacy-title">5. Base giuridica del trattamento</h4>

    <p>Il trattamento viene effettuato al fine di dare esecuzione alle misure precontrattuali e contrattuali
      richieste dall’interessato che, utilizzando i recapiti presenti sul sito o utilizzando gli specifici form
      contatta spontaneamente l’Azienda allo scopo di richiedere informazioni su beni /servizi. Al fondo dei
      form di contatto viene indicata specifica informativa e l’utente viene invitato a manifestare la presa
      visione della stessa spuntando la specifica casella. L’assenza di tale comportamento attivo non
      consente di poter inviare la propria richiesta.</p>

    <h4 class="privacy-title">6. Modalità del trattamento - Conservazione</h4>

    <p>I trattamenti effettuati tramite l’ausilio di strumenti cartacei /informatici con modalità e strumenti volti a
      garantire la massima sicurezza e riservatezza, non prevedono l’impiego di processi decisionali
      automatizzati. I trattamenti avvengono ad opera di soggetti di ciò appositamente incaricati (in qualità di
      incaricati e/o di responsabili) I dati saranno conservati per un periodo non superiore agli scopi per i quali i
      dati sono stati raccolti e successivamente trattati e per rispondere a sue necessità di recupero dati.</p>

    <h4 class="privacy-title">7. Comunicazione dei dati a terzi</h4>

    <p>I Suoi dati potranno essere comunicati a terzi appartenenti alle seguenti categorie:</p>
    <ul>
      <li>fornitori di servizi per la gestione del sistema informativo usato e delle reti di telecomunicazioni, ivi
        compresa la posta elettronica, newsletter e gestione siti internet;</li>
      <li>autorità competenti per adempimenti di obblighi di leggi e/o di disposizioni di organi pubblici, su
        richiesta.
      </li>
    </ul>

    <p>I soggetti appartenenti alle categorie suddette svolgono la funzione di Responsabile del trattamento dei
      dati, oppure operano in totale autonomia come distinti Titolari del trattamento. L’elenco dei responsabili è
      costantemente aggiornato e disponibile presso la sede del Titolare del Trattamento.</p>

    <h4 class="privacy-title">8. Ambito di diffusione</h4>

    <p>Non viene effettuata diffusione di dati.</p>

    <h4 class="privacy-title">9. Natura del conferimento dei dati e rifiuto</h4>

    <p>Per quanto riguarda la navigazione sul presente sito il conferimento dei dati è legato alla volontà
      dell’utente di navigare presso il suddetto sito dopo aver preso visione dell’informativa presente all’interno
      del banner riportato in homepage. Si ricorda che per evitare l’installazione di cookie è necessario non
      chiudere il suddetto cliccando sul tasto “rifiuta”, oppure utilizzando le apposite funzionalità offerte dal
      browser utilizzato per la navigazione.</p>

    <h4 class="privacy-title">10. Diritti degli interessati</h4>

    <p>Lei potrà far valere i propri diritti sotto riportati rivolgendosi al Titolare del trattamento, utilizzando una
      delle seguenti modalità:</p>
    <ul>
      <li>contattando la ns. sede al numero di telefono 02 3826 6440</li>
      <li>Inviando una mail all'indirizzo <a target="_blank" style="text-decoration: underline;"
          href="mailto:info@all-projects.it">info@all-projects.it</a></li>
    </ul>

    <p>I diritti sopra citati sono i seguenti: diritto di accesso ai propri dati e alle informazioni riguardanti
      l’interessato; diritto di rettifica dei dati inesatti o l&#39;integrazione di quelli incompleti; la cancellazione
      dei
      dati personali che La riguardano (nei casi previsti dalla normativa) ; diritto alla limitazione del trattamento
      dei Suoi dati personali (sempre nei casi previsti dalla normativa; diritto alla portabilità dei dati; diritto di
      opposizione al trattamento dei Suoi dati personali al ricorrere di situazioni particolari che La riguardano.</p>

    <p>Inoltre, il Titolare interromperà il trattamento nel momento in cui pervenga da parte sua la comunicazione
      di revoca del consenso precedentemente manifestato ove il consenso rappresenti base giuridica del
      trattamento.</p>

    <p>Qualora contatti il titolare è pregato di fornire l&#39;indirizzo di posta elettronica, il nominativo,
      l&#39;indirizzo e/o i
      numeri di telefono, al fine di permettere la corretta gestione della richiesta.</p>

    <h4 class="privacy-title">11. Reclamo all'autorità di controllo</h4>

    <p>L’interessato ha diritto a proporre reclamo presso l’Autorità di Controllo nel caso in cui le proprie richieste
      di informazioni rivolte al Titolare non abbiano determinato risposte soddisfacenti.</p>

    <p>L’Autorità di riferimento è Il Garante per la Protezione dei dati personali</p>

    <p><a style="text-decoration: underline;" target="_blank"
        href="http://www.garanteprivacy.it/web/guest/home/docweb/-/docweb-display/docweb/4535524">http://www.garanteprivacy.it/web/guest/home/docweb/-/docweb-display/docweb/4535524</a>
    </p>

    <p>Ultimo aggiornamento: ottobre 2024</p>
  </div>
</div>
<div class="copy-right" style="background-color: #1D1D1D;color: #fff; padding: 16px;text-align: center;">
  {{'GENERAL.CopyRight' | translate}}
</div>